import { FC, useState, useEffect } from "react";
import { Checkbox, Chip, Divider, FormControlLabel, Grid, MenuItem, Select, SelectChangeEvent, TextField, Typography } from "@mui/material";
import CustomSelect, { IOptions } from "../../FormFields/CustomSelect";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { fetchCountries } from '../../../store/countryStore/countryThunk';
import { fetchStates } from '../../../store/stateStore/stateThunk';
import styled from "@emotion/styled";

interface AddressProps {
  selected: any;
  methods:  any;
  isEdit?: boolean;
  addressType?: string;
}

const BpIcon = styled('span')(({ theme }) => ({
  borderRadius: 3,
  width: 15,
  height: 15,
  boxShadow:
  //   theme.palette.mode === 'dark'
      // ? '0 0 0 1px rgb(16 22 26 / 40%) ' :
      'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
  backgroundColor: 
  // theme.palette.mode === 'dark' ? '#394b59' : 
  '#f5f8fa',
  backgroundImage:
  //   theme.palette.mode === 'dark'
      // ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))' :
      'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
  '.Mui-focusVisible &': {
    outline: '2px auto rgba(19,124,189,.6)',
    outlineOffset: 2,
  },
  'input:hover ~ &': {
    backgroundColor: 
  //   theme.palette.mode === 'dark' ? '#30404d' : 
    '#ebf1f5',
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background:
      // theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 
      'rgba(206,217,224,.5)',
  },
}));

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: '#137cbd',
  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  '&:before': {
    display: 'block',
    width: 15,
    height: 15,
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
      " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
      "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
    content: '""',
  },
  'input:hover ~ &': {
    backgroundColor: '#106ba3',
  },
});

// Address component
const Address: FC<AddressProps> = ({selected, methods, isEdit, addressType}) => {
  const addressTitle1 = addressType == "Employee" ? "Present Address" : "Billing Address";
  const addressTitle2 = addressType == "Employee" ? "Permanent Address" : "Shipping Address";
  const dispatch = useAppDispatch();
  // const countriesList = useAppSelector(state => state.country.countries);
  const [countryOptions, setCountryOptions] = useState<IOptions[]>([]);
  const [stateOptions, setStateOptions] = useState<IOptions[]>([]);
  const [addressCountry, setAddressCountry] = useState('');
  const [addressState, setAddressState] = useState('');
  const [shipAddressCountry, setShipAddressCountry] = useState('');
  const [shipAddressState, setShipAddressState] = useState('');
  const [checked, setChecked] = useState(false);

  const onCheckHandler = (ischecked:boolean) => {
    let currentValues = methods.getValues();
    console.log(currentValues);
    setShipAddressCountry(currentValues.billingAddressCountry);
    setShipAddressState(currentValues.billingAddressState);
    methods.setValue("shippingAddressCountry", (ischecked) ? currentValues.billingAddressCountry : '');
    methods.setValue("shippingAddressCity", (ischecked) ? currentValues.billingAddressCity : '');
    methods.setValue("shippingAddressState", (ischecked) ? currentValues.billingAddressState : '');
    methods.setValue("shippingAddressLine1", (ischecked) ? currentValues.billingAddressLine1 : '');
    methods.setValue("shippingAddressLine2", (ischecked) ? currentValues.billingAddressLine2 : '');
    methods.setValue("shippingAddressPinCode", (ischecked) ? currentValues.billingAddressPinCode : '');
  }

  useEffect(() => {
    console.log("debugging address data");
    console.log(selected);
    console.log(isEdit);
    console.log("debugging address data end");
    
    
    // setCountryOptions(countriesList.map((c: any) => {
    //   return { label: c.name, value: c._id }
    // }));

    const setInitialData = () => {
    if(selected) {
      setShipAddressCountry('')
      setAddressCountry('')
      let address = selected.addresses;
      if (!Array.isArray(address) || address.length === 0) return;
      let shippingAddress: any;
      let billingAddress: any;
      if(addressType == "Employee") {
        shippingAddress = address.find((item: any) => item.type === 'Permanent Address');
        billingAddress = address.find((item: any) => item.type ===  'Present Address');
      } else {
        shippingAddress = address.find((item: any) => item.type === 'Shipping');
        billingAddress = address.find((item: any) => item.type ===  'Billing');
      }
      
      if(shippingAddress) {
        if (isEdit) {
          console.log("inside isediting from address ");
          methods.register("shippingAddressId");
          methods.setValue("shippingAddressId", shippingAddress._id);
        }
        setShipAddressCountry(shippingAddress?.country?._id || '');
        setShipAddressState(shippingAddress?.state?._id || '');
        methods.setValue("shippingAddressCity", shippingAddress?.city);
        methods.setValue("shippingAddressState", shippingAddress?.state?._id);
        methods.setValue("shippingAddressCountry", shippingAddress?.country?._id);
        methods.setValue("shippingAddressLine1", shippingAddress?.line1);
        methods.setValue("shippingAddressLine2", shippingAddress?.line2);
        methods.setValue("shippingAddressPinCode", shippingAddress?.code);
      }
      if(billingAddress) {
        if (isEdit) {
          methods.register("billingAddressId");
          methods.setValue("billingAddressId", billingAddress._id);
        }
        setAddressCountry(billingAddress?.country?._id || '');
        setAddressState(billingAddress?.state?._id || '');
        methods.setValue("billingAddressCity", billingAddress?.city);
        methods.setValue("billingAddressState", billingAddress?.state?._id);
        methods.setValue("billingAddressCountry", billingAddress?.country?._id);
        methods.setValue("billingAddressLine1", billingAddress?.line1);
        methods.setValue("billingAddressLine2", billingAddress?.line2);
        methods.setValue("billingAddressPinCode", billingAddress?.code);
      }
    }
    }

    setInitialData();
    getCountries();
    getStates()
  }, [selected, countryOptions, methods, stateOptions]);

  const getCountries = async () => {
    if (!countryOptions.length) {
      const data: any = await dispatch(fetchCountries());
      const options = data.payload.map((c: any) => {
        return { label: c.name, value: c._id }
      });
      setCountryOptions(options);
      // Auto-select first country when not in edit mode (new form)
      if (options.length >= 1 && !selected) {
        setAddressCountry(options[0].value);
        methods.setValue("billingAddressCountry", options[0].value);
        setShipAddressCountry(options[0].value);
        methods.setValue("shippingAddressCountry", options[0].value);
      }
    }
  }

  const getStates = async () => {
    if (!stateOptions.length) {
      const data: any = await dispatch(fetchStates());
      setStateOptions(data.payload.map((c: any) => {
        return { label: c.name, value: c._id }
      }));
    }
  }

  // useEffect(() => {
  //   console.log("useEffect called for setting up address ----  ", selected);
  //   setShipAddressCountry('')
  //   setAddressCountry('')
  //   if(selected) {
  //     console.log(selected.addresses);
  //     let address = selected.addresses;
  //     let shippingAddress: any = address.find((item: any) => item.type === 'Shipping');
  //     let billingAddress: any = address.find((item: any) => item.type === 'Billing');
  //     console.log(shippingAddress);
  //     console.log(billingAddress);

  //     if(shippingAddress) {
  //       if (isEdit) {
  //         console.log("inside isediting from address ");
  //         methods.register("shippingAddressId");
  //         methods.setValue("shippingAddressId", shippingAddress._id);
  //       }
  //       setShipAddressCountry(shippingAddress?.country || '')
  //       methods.setValue("shippingAddressCity", shippingAddress.city);
  //       methods.setValue("shippingAddressState", shippingAddress.state);
  //       methods.setValue("shippingAddressLine1", shippingAddress.line1);
  //       methods.setValue("shippingAddressLine2", shippingAddress.line2);
  //       methods.setValue("shippingAddressPinCode", shippingAddress.code);
  //     }
  //     if(billingAddress) {
  //       if (isEdit) {
  //         methods.register("billingAddressId");
  //         methods.setValue("billingAddressId", billingAddress._id);
  //       }
  //       setAddressCountry(billingAddress?.country || '')
  //       methods.setValue("billingAddressCity", billingAddress.city);
  //       methods.setValue("billingAddressState", billingAddress.state);
  //       methods.setValue("billingAddressLine1", billingAddress.line1);
  //       methods.setValue("billingAddressLine2", billingAddress.line2);
  //       methods.setValue("billingAddressPinCode", billingAddress.code);
  //     }
  //   }
  // }, [selected, methods])
 

  return (
    <>
      <Grid item xs={6} mt={1}>
        <Divider style={{marginRight:-8}}>
          <Chip label={addressTitle1} size="small" />
        </Divider>
      </Grid>
      <Grid item xs={6} mt={1}>
      <Divider style={{marginLeft:-8}}>
          <Chip label={<>{addressTitle2}<FormControlLabel style={{marginLeft:5}}
          control={
            <Checkbox
              checked={checked}
              disabled={(selected && !isEdit)? true : false}
              onChange={(event) => {
                setChecked(event.target.checked);
                onCheckHandler(event.target.checked);
              }}
              name="checked"
              color="primary"
              size="small"
                      sx={{
                          '&:hover': { bgcolor: 'transparent' },
                      }}
                      checkedIcon={<BpCheckedIcon />}
                      icon={<BpIcon />}
            />
          }
          label={<Typography variant="h6" style={{color:'#545454'}}>{addressType === "Employee" ? "Same as present add." : `Same as ${addressTitle1.toLowerCase()}`}</Typography>}
        /></>} size="small" />
        </Divider>
      </Grid>

      <Grid item xs={6.1} pr={2}>
      <Grid container spacing={2} rowSpacing={1} pt={-2}>

      {/* <Grid item xs={12}>
      <Typography variant="body1">{'Billing Address'}</Typography>
      </Grid> */}

      <Grid item xs={6}>
      <h5 className='c-label'>Country *</h5>
        {countryOptions?.length && <Select
                          className='c-text-field' 
                          {...methods.register("billingAddressCountry")}
                          id="country"
                          disableUnderline
                          required
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                border: "1.5px solid #e9ecf1",
                                // width: 255,
                                // marginLeft:'-29px !important',
                                boxShadow: 'none',
                                borderRadius: '5px'
                              }
                            }
                            }}
                          style={{width:'100%'}}
                          value={addressCountry}
                          disabled={(selected && !isEdit)? true : false}
                          onChange={(event: SelectChangeEvent<any>) => {
                            setAddressCountry(event.target.value);
                            methods.setValue("billingAddressCountry", event.target.value, { shouldValidate: true });
                          }}
                          size='small'
                          variant='outlined'
                          sx={{
                            boxShadow: "none",
                            // fontSize:12,
                            textAlign:'right',
                            '& .MuiOutlinedInput-input': {p: 0.5},
                            // '& .MuiSelect-select': { p:0 },
                            marginBottom:'3px',
                            ".MuiOutlinedInput-notchedOutline": { border: 0 },
                            "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                              {
                                border: 0,
                              },
                            "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                              {
                                border: 0,
                              },
                          }}
                        >
                        {countryOptions && countryOptions.map((option)=>
                            <MenuItem value={option.value} key={option.value}>{option.label}</MenuItem>
                          )}
                          </Select>}
                          <p style={{color: "#c33b3b"}}>{methods.formState.errors.billingAddressCountry?.message ?? ""}</p>
      </Grid>
      <Grid item xs={6}>
      <h5 className='c-label'>City</h5>
                    <TextField
                    placeholder='City' 
                    className='c-text-field' 
                    name="billingAddressCity"
                    {...methods.register('billingAddressCity')}
                    variant="standard" 
                    sx={{width:'100%'}}
                    size='small'
                    InputProps={{
                      disableUnderline: true,
                      readOnly: (selected && !isEdit)? true : false
                    }}/>
                    <p style={{color: "#c33b3b"}}>{methods.formState.errors.billingAddressCity?.message ?? ""}</p>
      </Grid>
      <Grid item xs={6}>
      <h5 className='c-label'>State</h5>
      {stateOptions?.length && 
        <Select
          className='c-text-field' 
          {...methods.register("billingAddressState")}
          id="state"
          disableUnderline
          required
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1.5px solid #e9ecf1",
                // width: 255,
                // marginLeft:'-29px !important',
                boxShadow: 'none',
                borderRadius: '5px'
              }
            }
          }}
          style={{width:'100%'}}
          value={addressState}
          disabled={(selected && !isEdit)? true : false}
          onChange={(event: SelectChangeEvent<any>) => {
            setAddressState(event.target.value);
            methods.setValue("billingAddressState", event.target.value, { shouldValidate: true });
          }}
          size='small'
          variant='outlined'
          sx={{
            boxShadow: "none",
            // fontSize:12,
            textAlign:'right',
            '& .MuiOutlinedInput-input': {p: 0.5},
            // '& .MuiSelect-select': { p:0 },
            marginBottom:'3px',
            ".MuiOutlinedInput-notchedOutline": { border: 0 },
            "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
              {
                border: 0,
              },
            "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
              {
                border: 0,
              },
          }}
        >
        {stateOptions && stateOptions.map((option)=>
          <MenuItem value={option.value} key={option.value}>{option.label}</MenuItem>
        )}
        </Select>
      }
      <p style={{color: "#c33b3b"}}>{methods.formState.errors.billingAddressState?.message ?? ""}</p>
      </Grid>

      <Grid item xs={6}>
      <h5 className='c-label'>Line 1</h5>
                    <TextField
                    placeholder='Line 1' 
                    className='c-text-field'
                    {...methods.register('billingAddressLine1')}
                    variant="standard" 
                    sx={{width:'100%'}}
                    size='small'
                    InputProps={{
                      disableUnderline: true,
                      readOnly: (selected && !isEdit)? true : false
                    }}/>
                    <p style={{color: "#c33b3b"}}>{methods.formState.errors.billingAddressLine1?.message ?? ""}</p>
      </Grid>
      <Grid item xs={6}>
      <h5 className='c-label'>Line 2</h5>
                    <TextField
                    placeholder='Line 2' 
                    className='c-text-field' 
                    {...methods.register('billingAddressLine2')}
                    variant="standard" 
                    sx={{width:'100%'}}
                    size='small'
                    InputProps={{
                      disableUnderline: true,
                      readOnly: (selected && !isEdit)? true : false
                    }}/>
                    <p style={{color: "#c33b3b"}}>{methods.formState.errors.billingAddressLine2?.message ?? ""}</p>
      </Grid>
      <Grid item xs={6}>
      <h5 className='c-label'>Pincode</h5>
                    <TextField
                    placeholder='Pincode' 
                    type="number"
                    className='c-text-field' 
                    {...methods.register('billingAddressPinCode')}
                    variant="standard" 
                    sx={{width:'100%'}}
                    size='small'
                    InputProps={{
                      disableUnderline: true,
                      readOnly: (selected && !isEdit)? true : false
                    }}/>
                    <p style={{color: "#c33b3b"}}>{methods.formState.errors.billingAddressPinCode?.message ?? ""}</p>
      </Grid>

      </Grid>
      </Grid>
      {/* <Grid item xs={12}>
        <Divider/>
      </Grid> */}
      
      <Grid item xs={5.9} style={{borderLeft:'1px solid rgba(0, 0, 0, 0.12)'}}>
      
      <Grid container spacing={2} rowSpacing={1} >

        {/* <Grid item xs={12} mt={-3.2}>
        <Typography variant="body1">{'Shipping Address'}</Typography>
      </Grid> */}

      <Grid item xs={6}>
      <h5 className='c-label'>Country *</h5>
        {countryOptions?.length && <Select
                          className='c-text-field' 
                          {...methods.register("shippingAddressCountry")}
                          id="country"
                          disableUnderline
                          required
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                border: "1.5px solid #e9ecf1",
                                // width: 255,
                                // marginLeft:'-29px !important',
                                boxShadow: 'none',
                                borderRadius: '5px'
                              }
                            }
                            }}
                          style={{width:'100%'}}
                          value={shipAddressCountry}
                          disabled={((selected && !isEdit) || checked)? true : false}
                          onChange={(event: SelectChangeEvent<any>) => {
                            setShipAddressCountry(event.target.value);
                            methods.setValue("shippingAddressCountry", event.target.value, { shouldValidate: true });
                          }}
                          size='small'
                          variant='outlined'
                          sx={{
                            boxShadow: "none",
                            // fontSize:12,
                            textAlign:'right',
                            '& .MuiOutlinedInput-input': {p: 0.5},
                            // '& .MuiSelect-select': { p:0 },
                            marginBottom:'3px',
                            ".MuiOutlinedInput-notchedOutline": { border: 0 },
                            "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                              {
                                border: 0,
                              },
                            "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                              {
                                border: 0,
                              },
                          }}
                        >
                        {countryOptions && countryOptions.map((option)=>
                            <MenuItem value={option.value} key={option.value}>{option.label}</MenuItem>
                          )}
                          </Select>}
                          <p style={{color: "#c33b3b"}}>{methods.formState.errors.shippingAddressCountry?.message ?? ""}</p>
      </Grid>
      <Grid item xs={6}>
      <h5 className='c-label'>City *</h5>
      <TextField
      placeholder='City' 
      className='c-text-field' 
      name="shippingAddressCity"
      {...methods.register('shippingAddressCity')}
      variant="standard" 
      sx={{width:'100%'}}
      size='small'
      disabled={(checked)? true : false}
      InputProps={{
        // shrink: true,
        disableUnderline: true,
        readOnly: ((selected && !isEdit) || checked)? true : false
      }}/>
      <p style={{color: "#c33b3b"}}>{methods.formState.errors.shippingAddressCity?.message ?? ""}</p>
      </Grid>
      <Grid item xs={6}>
        <h5 className='c-label'>State</h5>
        {stateOptions?.length && 
          <Select
            className='c-text-field' 
            {...methods.register("shippingAddressState")}
            id="shippingAddressState"
            disableUnderline
            required
            MenuProps={{
              PaperProps: {
                sx: {
                  border: "1.5px solid #e9ecf1",
                  // width: 255,
                  // marginLeft:'-29px !important',
                  boxShadow: 'none',
                  borderRadius: '5px'
                }
              }
            }}
            style={{width:'100%'}}
            value={shipAddressState}
            disabled={((selected && !isEdit) || checked)? true : false}
            onChange={(event: SelectChangeEvent<any>) => {
              setShipAddressState(event.target.value);
              methods.setValue("shippingAddressState", event.target.value, { shouldValidate: true });
            }}
            size='small'
            variant='outlined'
            sx={{
              boxShadow: "none",
              // fontSize:12,
              textAlign:'right',
              '& .MuiOutlinedInput-input': {p: 0.5},
              // '& .MuiSelect-select': { p:0 },
              marginBottom:'3px',
              ".MuiOutlinedInput-notchedOutline": { border: 0 },
              "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                {
                  border: 0,
                },
              "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                {
                  border: 0,
                },
            }}
          >
          {stateOptions && stateOptions.map((option)=>
            <MenuItem value={option.value} key={option.value}>{option.label}</MenuItem>
          )}
          </Select>
        }
        <p style={{color: "#c33b3b"}}>{methods.formState.errors.shippingAddressState?.message ?? ""}</p>
      </Grid>

      <Grid item xs={6}>
      <h5 className='c-label'>Line 1</h5>
                    <TextField
                    placeholder='Line 1' 
                    className='c-text-field' 
                    {...methods.register('shippingAddressLine1')}
                    variant="standard" 
                    sx={{width:'100%'}}
                    size='small'
                    disabled={(checked)? true : false}
                    InputProps={{
                      // shrink: true,
                      disableUnderline: true,
                      readOnly: ((selected && !isEdit) || checked)? true : false
                    }}/>
                    <p style={{color: "#c33b3b"}}>{methods.formState.errors.shippingAddressLine1?.message ?? ""}</p>
      </Grid>
      <Grid item xs={6}>
      <h5 className='c-label'>Line 2</h5>
                    <TextField
                    placeholder='Line 2' 
                    className='c-text-field' 
                    {...methods.register('shippingAddressLine2')}
                    variant="standard" 
                    sx={{width:'100%'}}
                    size='small'
                    disabled={(checked)? true : false}
                    InputProps={{
                      // shrink: true,
                      disableUnderline: true,
                      readOnly: ((selected && !isEdit) || checked)? true : false
                    }}/>
                    <p style={{color: "#c33b3b"}}>{methods.formState.errors.shippingAddressLine2?.message ?? ""}</p>
      </Grid>
      <Grid item xs={6}>
      <h5 className='c-label'>Pincode</h5>
                    <TextField
                    placeholder='Pincode' 
                    className='c-text-field'
                    type="number"
                    {...methods.register('shippingAddressPinCode')}
                    variant="standard" 
                    sx={{width:'100%'}}
                    size='small'
                    disabled={(checked)? true : false}
                    InputProps={{
                      // shrink: true,
                      disableUnderline: true,
                      readOnly: ((selected && !isEdit) || checked)? true : false
                    }}/>
                    <p style={{color: "#c33b3b"}}>{methods.formState.errors.shippingAddressPinCode?.message ?? ""}</p>
      </Grid>

      </Grid>
      </Grid>

      
      {/* <Grid item xs={4}>
        <CustomTextField label="City" name="shippingAddressCity" required variant="standard" InputProps={{ shrink: true, readOnly: ((selected && !isEdit) || checked)? true : false }} disabled={(checked)? true : false}/>
      </Grid>
      <Grid item xs={4}>
        <CustomTextField label="State" name="shippingAddressState" variant="standard" InputProps={{ shrink: true, readOnly: ((selected && !isEdit) || checked)? true : false }} disabled={(checked)? true : false}/>
      </Grid>
      <Grid item xs={4}>
        <CustomTextField label="Line 1" name="shippingAddressLine1" variant="standard" InputProps={{ shrink: true, readOnly: ((selected && !isEdit) || checked)? true : false }} disabled={(checked)? true : false}/>
      </Grid>
      <Grid item xs={4}>
        <CustomTextField label="Line 2" name="shippingAddressLine2" variant="standard" InputProps={{ shrink: true, readOnly: ((selected && !isEdit) || checked)? true : false }}  disabled={(checked)? true : false}/>
      </Grid>

      <Grid item xs={4}>
        <CustomTextField label="Pincode" name="shippingAddressPinCode" variant="standard" InputProps={{ shrink: true, readOnly: ((selected && !isEdit) || checked)? true : false }} disabled={(checked)? true : false} />
      </Grid> */}
    </>
  );
};

export default Address;
